import React, { FC, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import ContactInfo from 'containers/VerticalPage/common/ContactInfo/ContactInfo'
import { tabsIds, getTabsList, overviewMapping } from './utils'
import Tabs from 'components/common/Tabs'
import Overview from '../Overview/Overview'
import Activity from '../Activity/Activity'
import styles from 'containers/VerticalPage/common/styles.scss'
import GraphContainer from 'containers/VerticalPage/common/GraphContainer/GraphContainer'
import { selectCurrentZone } from 'store/global'
import type { CurrentZone } from 'utils/types'
import modularStyles from './Details.module.scss'

const tabsList = getTabsList()

type TabContent = {
  [key in (typeof tabsIds)[keyof typeof tabsIds]]: JSX.Element | null
}

const Details: FC = () => {
  const [activeTab, setActiveTab] = useState<(typeof tabsIds)[keyof typeof tabsIds]>(tabsIds.OVERVIEW)
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  const handleTabClick = (event: React.SyntheticEvent<Element, Event>, value: number) => {
    setActiveTab(value as (typeof tabsIds)[keyof typeof tabsIds])
  }

  const contentByTabMap: TabContent = useMemo(
    () => ({
      [tabsIds.OVERVIEW]: <Overview />,
      [tabsIds.ACTIVITY]: <Activity />,
      [tabsIds.CONTACT_INFO]: <ContactInfo />,
      [tabsIds.TAX_RETURN]: null,
    }),
    [],
  )

  return (
    <>
      <div className={modularStyles.container}>
        <div className={styles.tabsWrapper} style={{ paddingBottom: '12px' }}>
          <Tabs
            tabs={tabsList}
            value={activeTab}
            disabledIds={[tabsIds.TAX_RETURN]}
            tabsClasses={{
              root: styles.root,
              flexContainer: styles.flexContainer,
            }}
            tabClasses={{
              root: styles.tabRoot,
              disabled: styles.tabDisabled,
            }}
            onChange={handleTabClick}
          />
          {currentZone?.nftGraphIndices && (
            <GraphContainer zone={currentZone.nftGraphIndices} overviewMapping={overviewMapping} />
          )}
        </div>
        {contentByTabMap[activeTab]}
      </div>
    </>
  )
}

export default Details
